import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/all-on-4-implants/hero";
import WhatAndWhy from "../components/all-on-4-implants/what-and-why";
import Process from "../components/all-on-4-implants/process";
import AfterCare from "../components/all-on-4-implants/aftercare";
import Benifits from "../components/all-on-4-implants/benefits";
import CTA from "../components/all-on-4-implants/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionsAllOn4 from "../components/all-on-4-implants/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "All-on-Four Dental Implants in Ilkley | Regent Dental",
    serviceType: "All-on-4 Dental Implants",
    url: "https://www.regent-dental.co.uk/all-on-4-dental-implants",
    description:
      "All-on-4 dental implants at Regent Dental provide a full set of teeth on just four implants, perfect for those who want a complete smile transformation.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Is the procedure actually completed in one day?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "This is one of the main advantages of the All on 4 dental implants. The implants can support a temporary bridge from day one for most patients. After approximately 4 months, we replace the temporary bridge with a permanent one over a few visits.",
        },
      },
      {
        "@type": "Question",
        name: "How are full arch implants different from traditional dentures?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Full arch implants are permanently anchored to the jawbone, providing greater stability, chewing power, and a more natural look and feel. They don’t slip or need adhesives, and they help prevent bone loss in the jaw.",
        },
      },
      {
        "@type": "Question",
        name: "How long do full arch implants last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "With proper care, full arch implants can last 20 years or longer. Good oral hygiene, regular check-ups, and a healthy lifestyle support longevity.",
        },
      },
      {
        "@type": "Question",
        name: "Are there any risks or complications?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Risks such as infection, implant failure, or nerve damage exist but are rare. Choosing an experienced dentist and following aftercare reduces these risks.",
        },
      },
      {
        "@type": "Question",
        name: "I have gum disease, can I have implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, but gum disease must be treated before implant placement. Periodontal patients may face slightly higher complication risks, but with maintenance, implants are still possible.",
        },
      },
      {
        "@type": "Question",
        name: "Who is suitable for All on 4 dental implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "All on 4 implants are ideal for patients with few or failing teeth and bone loss in the jaw. They provide a secure alternative to dentures, often without the need for bone grafting.",
        },
      },
      {
        "@type": "Question",
        name: "How long do implants last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Implants have high success rates. Studies show 90% of implants placed 10 years ago are still functional. Longevity depends on hygiene, check-ups, and lifestyle.",
        },
      },
      {
        "@type": "Question",
        name: "How should I care for my full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Brush twice daily, floss, use antibacterial mouthwash, and visit your dentist regularly. Water flossers and professional cleanings help maintain implants.",
        },
      },
      {
        "@type": "Question",
        name: "I’m a really nervous patient, what are my options?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We offer a relaxed, informal approach and IV sedation for nervous patients. Sedation induces deep relaxation, helping you undergo treatment comfortably.",
        },
      },
      {
        "@type": "Question",
        name: "Will my speech be affected by full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Speech may be affected initially, but most patients quickly adapt. In fact, speech often improves over time with implants.",
        },
      },
      {
        "@type": "Question",
        name: "Can dental implants be done in a single day?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, in some cases. Same-day implants allow placement with a temporary crown or bridge in one visit, but bone health and overall condition must be assessed first.",
        },
      },
      {
        "@type": "Question",
        name: "What is the difference between full arch implants and traditional dentures?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Full arch implants are secured with 4–6 implants, do not slip, and preserve the jawbone. Dentures are not fixed, may slip, and don’t prevent bone loss.",
        },
      },
      {
        "@type": "Question",
        name: "What is the average lifespan of dental implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Studies show 90% of implants placed 10 years ago are still working. Success depends on regular dental care and personal oral hygiene habits.",
        },
      },
      {
        "@type": "Question",
        name: "How should I maintain and clean my full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Clean twice daily with brushing and flossing, use antibacterial mouthwash, and visit for hygienist cleanings. Water flossers are recommended for thorough cleaning.",
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>All-on-Four Dental Implants in Ilkley | Regent Dental</title>
        <meta
          name="description"
          content="Regain your full smile with full arch dental implants in Ilkley. Regent Dental offers permanent, fixed teeth solutions that restore full function and confidence."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/all-on-4-dental-implants"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <Benifits />
      <QuestionsAllOn4 />
      <CTA />
      <Contact heading={"Book your all on four dental implant consultation"} />
      <Footer />
    </React.Fragment>
  );
}

export default Index;
